import type { DcmTagSheetParseResult } from '../../../../../apis/campaignGraphqlManager/dcmTagSheet/types';
import type { RawTagSheetParseResultWithAdIds } from '../types';

export const enrichDcmTagSheetDataWithIds = (result: DcmTagSheetParseResult): RawTagSheetParseResultWithAdIds => ({
  ...result,
  unmappedAds: result.unmappedAds.map((ad, i) => ({ ...ad, id: `unmapped-ad-${i}` })),
  lineItems: result.lineItems.map((li) => ({
    ...li,
    ads: li.ads.map((ad, i) => ({ ...ad, id: `${li.lineItemId}-ad-${i}` })),
  })),
});
